import { Component, Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './synthetic.component.ajs';

@Directive({
  selector: 'cng-hypervision-skill-synthetic-upgrade',
})
export class HypervisionSkillSyntheticUpgradeComponent extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-hypervision-skill-synthetic',
  template: '<cng-hypervision-skill-synthetic-upgrade></cng-hypervision-skill-synthetic-upgrade>',
})
export class HypervisionSkillSyntheticComponent {}
